import { resolveTourStepsForRole } from "../resolveTourStepsForRole";

const SETTINGS_FULL = ["Admin", "Sales Director"];

function copy(title, content) {
  return {
    Admin: { title, content },
    "Sales Director": { title, content },
  };
}

const STEP_DEFS = [
  {
    roles: SETTINGS_FULL,
    selector: '[data-tour="edit-user-header"]',
    placement: "bottom",
    copy: copy(
      "User header",
      "See who you are editing—avatar, name, current roles, and user ID. Use Back to return to the directory. Save applies all changes; Delete permanently removes this account."
    ),
  },
  {
    roles: SETTINGS_FULL,
    selector: '[data-tour="edit-user-profile-info"]',
    placement: "bottom",
    copy: copy(
      "Profile information",
      "View contact details at a glance. Tap the pencil to edit full name, username, password, mobile, email, and location inline."
    ),
  },
  {
    roles: SETTINGS_FULL,
    selector: '[data-tour="edit-user-platform-account"]',
    placement: "bottom",
    copy: copy(
      "Account settings",
      "Control whether the user is active, read-only, allowed to see lead additional notes, and whether they receive system emails or SMS. Admin accounts lock several of these toggles."
    ),
  },
  {
    roles: SETTINGS_FULL,
    selector: '[data-tour="edit-user-territory-settings"]',
    placement: "bottom",
    copy: copy(
      "Territory assignment",
      "Turn on Assign to territory, then pick one or more territories. Reps and managers only see leads in their assigned markets."
    ),
  },
  {
    roles: SETTINGS_FULL,
    selector: '[data-tour="edit-user-lead-categories"]',
    placement: "bottom",
    copy: copy(
      "Lead category visibility",
      "Limit which lead categories this user can see. If none are selected, they default to Cold Lead only. Admin users use the default visibility."
    ),
  },
  {
    roles: SETTINGS_FULL,
    selector: '[data-tour="edit-user-permissions"]',
    placement: "bottom",
    copy: copy(
      "Role permissions",
      "Assign Admin, Sales Director, Manager, or Sales Rep access. Only one Admin is allowed; existing Admin roles are protected and cannot be changed here."
    ),
  },
  {
    roles: SETTINGS_FULL,
    selector: '[data-tour="edit-user-fillquick"]',
    placement: "top",
    copy: copy(
      "FillQuick credentials",
      "Optional per-user FillQuick User ID and API key for proposal push. Leave the API key blank to keep the stored value; if missing, the company credentials are used."
    ),
  },
];

export const EDIT_USER_TOUR_STEPS = (role, options) =>
  resolveTourStepsForRole(STEP_DEFS, role, options);
